import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import {
  getQuotaMaintenanceViewAllEndpoint,
  getQuotaMaintenanceHistoryEndpoint,
  getQuotaMaintenanceAuditLogEndpoint,
  postQuotaMaintenanceFilterListEndpoint,
  postQuotaMaintenanceSearchEndpoint,
} from '../../../common/endpoints';

export const fetchQuotaMaintenanceViewAll = createApi(getQuotaMaintenanceViewAllEndpoint, 'GET');
export const fetchQuotaMaintenanceHistory = createApi(getQuotaMaintenanceHistoryEndpoint, 'GET');
export const fetchQuotaMaintenanceAuditLog = createApi(getQuotaMaintenanceAuditLogEndpoint, 'GET');
export const fetchQuotaMaintenanceFilterList = createApi(postQuotaMaintenanceFilterListEndpoint, 'POST');
export const fetchQuotaMaintenanceSearch = createApi(postQuotaMaintenanceSearchEndpoint, 'POST');

const QuotaMaintenance = createSlice({
  name: 'QuotaMaintenance',
  initialState: {
    data: {},
    loading: false,
    error: null,
    historyLogData: [],
    historyLoading: false,
    historyError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuotaMaintenanceViewAll.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuotaMaintenanceViewAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchQuotaMaintenanceViewAll.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchQuotaMaintenanceSearch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuotaMaintenanceSearch.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchQuotaMaintenanceSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchQuotaMaintenanceHistory.pending, (state) => {
        state.historyLoading = true;
        state.historyError = null;
      })
      .addCase(fetchQuotaMaintenanceHistory.fulfilled, (state, action) => {
        state.historyLoading = false;
        state.historyLogData = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchQuotaMaintenanceHistory.rejected, (state, action) => {
        state.historyLoading = false;
        state.historyError = action.payload;
      })
      .addCase(fetchQuotaMaintenanceAuditLog.pending, (state) => {
        state.historyLoading = true;
        state.historyError = null;
      })
      .addCase(fetchQuotaMaintenanceAuditLog.fulfilled, (state, action) => {
        state.historyLoading = false;
        const payload = action.payload;
        if (payload && Array.isArray(payload.auditList)) {
          state.historyLogData = payload.auditList;
        } else if (Array.isArray(payload)) {
          state.historyLogData = payload;
        } else {
          state.historyLogData = [];
        }
      })
      .addCase(fetchQuotaMaintenanceAuditLog.rejected, (state, action) => {
        state.historyLoading = false;
        state.historyError = action.payload;
      });
  },
});

export default QuotaMaintenance.reducer;